export default __webpack_public_path__ + "static/media/Amanda_Baroni_Elementos_da_Minha_Natureza_3.ef143a04.jpg";